export default __webpack_public_path__ + "static/media/azure.dc95e4d6.png";